export default {
    list: {
        title: "Empresas",
        subtitle: "Gestionar empresas internacionales",
        newCompany: "Nueva Empresa",
        loading: "Cargando empresas...",
        filters: {
            searchPlaceholder: "Buscar por nombre, email, ID fiscal...",
            statusPlaceholder: "Filtrar por estado",
            companyTypePlaceholder: "Filtrar por tipo de empresa",
            countryPlaceholder: "Filtrar por país",
            allTypes: "Todos los tipos",
            allStatuses: "Todos los estados",
            allCountries: "Todos los países",
            companyTypes: {
                sender: "Expedidor",
                receiver: "Destinatario",
                freightForwarder: "Agente de Carga",
                carrier: "Transportista",
                customsBroker: "Agente Aduanero",
                portAuthority: "Autoridad Portuaria",
                insuranceProvider: "Proveedor de Seguros",
            },
        },
        table: {
            title: "Empresas",
            description: "Lista completa de empresas",
            headers: {
                companyType: "Tipo de Empresa",
                companyName: "Nombre de Empresa",
                legalName: "Nombre Legal",
                country: "País",
                status: "Estado",
                createdAt: "Fecha de Creación",
                actions: "Acciones",
            },
            edit: "Editar",
            manageTeam: "Equipo",
            menuConfig: "Config",
            noCompanies: {
                title: "No se encontraron empresas",
                message: "Intenta modificar los filtros de búsqueda",
                emptyMessage: "Comienza creando tu primera empresa",
                createFirst: "Crear la primera empresa",
            },
        },
        status: {
            active: "Activo",
            suspended: "Suspendido",
            inactive: "Inactivo",
        },
        confirmDelete: "¿Estás seguro de que quieres eliminar esta empresa?",
    },
    form: {
        edit: {
            title: "Editar Empresa",
            subtitle: "Editar detalles de la empresa",
        },
        create: {
            title: "Nueva Empresa",
            subtitle: "Crear una nueva empresa",
        },
        loading: "Cargando empresa...",
        back: "Atrás",
        sections: {
            general: "Información General",
            address: "Dirección",
            contacts: "Contactos",
            notes: "Notas Adicionales",
        },
        stepper: {
            step1: {
                title: "Información de Empresa",
                description: "Información básica y detalles legales de la empresa",
            },
            step2: {
                title: "Gestión de Equipo",
                description: "Agregar miembros del equipo que pueden acceder a la plataforma",
                roles: {
                    operator: "Operador",
                    companyAdmin: "Administrador de Empresa",
                },
                fields: {
                    email: "Email",
                    emailPlaceholder: "nombre@empresa.com",
                    firstName: "Nombre",
                    firstNamePlaceholder: "Ingresa nombre",
                    lastName: "Apellido",
                    lastNamePlaceholder: "Ingresa apellido",
                    role: "Rol",
                    rolePlaceholder: "Selecciona rol",
                },
                addMember: "Agregar Miembro del Equipo",
                addButton: "Agregar",
                remove: "Eliminar",
                membersList: "Miembros del Equipo",
                noMembers: "No se agregaron miembros del equipo. Puedes agregarlos después de crear la empresa.",
                duplicateEmail: "Este email ya ha sido agregado al equipo",
            },
        },
        fields: {
            companyType: "Tipo de Empresa",
            companyTypePlaceholder: "Selecciona el tipo de empresa",
            companyTypes: {
                sender: "Expedidor",
                receiver: "Destinatario",
                freightForwarder: "Agente de Carga",
                carrier: "Transportista",
                customsBroker: "Agente Aduanero",
                portAuthority: "Autoridad Portuaria",
                insuranceProvider: "Proveedor de Seguros",
            },
            companyName: "Nombre de Empresa",
            companyNamePlaceholder: "Ingresa el nombre de la empresa",
            legalName: "Nombre Legal",
            legalNamePlaceholder: "Ingresa el nombre legal",
            entityType: "Tipo de Entidad",
            entityTypePlaceholder: "Selecciona el tipo de entidad",
            taxId: "ID Fiscal",
            taxIdPlaceholder: "Ingresa el ID fiscal",
            status: "Estado",
            statusPlaceholder: "Selecciona el estado",
            street: "Calle",
            streetPlaceholder: "Ingresa la dirección completa",
            city: "Ciudad",
            cityPlaceholder: "Ingresa la ciudad",
            state: "Estado/Provincia",
            statePlaceholder: "Ingresa estado o provincia",
            postalCode: "Código Postal",
            postalCodePlaceholder: "Ingresa el código postal",
            country: "País",
            countryPlaceholder: "Selecciona el país",
            email: "Email",
            emailPlaceholder: "nombre@empresa.com",
            phone: "Teléfono",
            phonePlaceholder: "+34 123 456 789",
            notes: "Notas",
            notesPlaceholder: "Ingresa notas adicionales sobre la empresa...",
        },
        actions: {
            cancel: "Cancelar",
            save: "Guardar Cambios",
            create: "Crear Empresa",
            next: "Siguiente",
            back: "Atrás",
            previous: "Anterior",
            menuConfig: "Configuración Menú",
        },
        saving: "Guardando company...",
        creating: "Creando company...",
    },
    team: {
        title: "Equipo de {{companyName}}",
        subtitle: "Gestionar miembros del equipo e invitaciones pendientes",
        loading: "Cargando equipo...",
        errorLoading: "Error al cargar los datos del equipo",
        companyNotFound: "Empresa no encontrada",
        backToCompanies: "Volver a Empresas",
        addMember: "Añadir Miembro",
        activeMembers: "Miembros Activos",
        activeMembersDescription: "Usuarios activos con acceso a la plataforma",
        pendingInvitations: "Invitaciones Pendientes",
        pendingInvitationsDescription: "Invitaciones por email esperando aceptación",
        noActiveMembers: "No hay miembros activos",
        roles: {
            superAdmin: "Super Admin",
            companyAdmin: "Administrador de Empresa",
            operator: "Operador",
            viewer: "Visualizador",
        },
        status: {
            active: "Activo",
            inactive: "Inactivo",
            pending: "Pendiente",
            expired: "Expirado",
        },
        table: {
            headers: {
                name: "Nombre",
                email: "Email",
                role: "Rol",
                status: "Estado",
                joinedAt: "Se unió",
                invitedAt: "Invitado",
                expiresAt: "Expira",
            },
        },
        form: {
            email: "Correo",
            emailPlaceholder: "miembro@ejemplo.com",
            firstName: "Nombre",
            firstNamePlaceholder: "Juan",
            lastName: "Apellido",
            lastNamePlaceholder: "García",
            role: "Rol",
            addButton: "Añadir Miembro",
            addingMember: "Añadiendo miembro del equipo...",
        },
        error: {
            emailRequired: "El correo es obligatorio",
            addingMember: "Error al añadir miembro del equipo",
            updatingMember: "Error al actualizar miembro del equipo",
            removingMember: "Error al eliminar miembro del equipo",
            resendingInvitation: "Error al reenviar la invitación",
        },
        success: {
            memberAdded: "Miembro del equipo añadido con éxito",
            memberUpdated: "Miembro del equipo actualizado con éxito",
            memberRemoved: "Miembro del equipo eliminado con éxito",
            invitationResent: "Invitación reenviada con éxito",
        },
        actions: {
            edit: "Editar",
            remove: "Eliminar",
            resend: "Reenviar",
        },
        editMember: {
            title: "Editar Miembro del Equipo",
            name: "Nombre",
            email: "Correo electrónico",
            isActive: "Activo",
            saveButton: "Guardar Cambios",
        },
        removeMember: {
            title: "Eliminar Miembro del Equipo",
            confirmation: "¿Estás seguro de que quieres eliminar {{name}} ({{email}}) de esta empresa?",
            sendNotificationEmail: "Enviar correo electrónico de notificación al usuario",
            confirmButton: "Eliminar Miembro",
        },
        resetData: {
            menuItem: "Restablecer Datos",
            title: "Restablecer Datos de Usuario",
            warning: "Esto eliminará permanentemente todos los datos operativos de la empresa de este usuario. El usuario y la empresa se conservarán.",
            mode: "Modo de Ejecución",
            dryRun: "Simulación (solo vista previa)",
            force: "Forzar (eliminar datos)",
            run: "Ejecutar",
            running: "Ejecutando...",
            completed: "Completado",
            error: "Se produjo un error",
            close: "Cerrar",
        },
    },
    menuConfig: {
        title: "Configuración Menú",
        subtitle: "Configurar elementos del menú para {{companyName}}",
        back: "Volver a Empresa",
        backToCompanies: "Volver a Empresas",
        companyNotFound: "Empresa no encontrada",
        loading: "Cargando configuración del menú...",
        override: {
            title: "Anulación de Configuración Menú",
            descriptionHasOverride: "Esta empresa tiene una configuración de menú personalizada. Los cambios aquí anularán la configuración global.",
            descriptionNoOverride:
                "Esta empresa utiliza la configuración de menú global. Habilita la anulación para personalizar los elementos del menú solo para esta empresa.",
            deleteButton: "Eliminar Anulación",
            deleteConfirm: "¿Estás seguro de que quieres eliminar la anulación del menú? La empresa utilizará la configuración global.",
            deleteSuccess: "Anulación del menú eliminada con éxito",
            deleteError: "Error al eliminar la anulación del menú",
            saveButton: "Guardar Anulación",
            saving: "Guardando...",
            saveSuccess: "Anulación del menú guardada con éxito",
            saveError: "Error al guardar la anulación del menú",
            resetButton: "Restablecer",
            loading: "Cargando configuración...",
            noItems: "No hay elementos de menú disponibles para este tipo de empresa",
            alwaysEnabled: "Siempre Habilitado",
            key: "Clave",
            badge: "Anulación",
        },
    },
};
